import { Node, StatusEnum, Uni } from '@vendia/management-api-types'
import { UniFeatures } from 'src/types/types'

export const isUniOrNodePending = (uni?: Uni, node?: Node, ignoreZeroDowntimeFeature?: boolean) => {
  if (!uni) return false
  const isZeroDowntimeFeatureDisabled = !uni?.features?.includes(UniFeatures.ZERO_DOWNTIME_ENABLED)
  var uniPendingStates = [
    StatusEnum.PendingRegistration,
    StatusEnum.Adding,
    StatusEnum.Deploying,
    StatusEnum.Stopped,
    StatusEnum.Servicing,
  ]
  if (ignoreZeroDowntimeFeature || isZeroDowntimeFeatureDisabled) {
    uniPendingStates.push(StatusEnum.Updating)
  }
  const isUniPending = uniPendingStates.includes(uni?.status as StatusEnum)
  const isNodePending = node?.status === StatusEnum.PendingRegistration || node?.status === StatusEnum.Deploying
  return isUniPending || isNodePending
}
